export const seedExercises: readonly string[] = [
  "Squat",
  "Back squat",
  "Front squat",
  "Overhead squat",
  "Box squat",
  "Split squat",
  "Bulgarian split squat",
  "Goblet squat",
  "Pause squat",
  "Zercher squat",
  "Air squat",
  "Pistol squat",
  "Deadlift",
  "Romanian deadlift",
  "Stiff leg deadlift",
  "Sumo deadlift",
  "Deficit deadlift",
  "Trap bar deadlift",
  "Single leg deadlift",
  "Rack pull",
  "Good morning",
  "Hip thrust",
  "Glute bridge",
  "Back extension",
  "Glute ham raise",
  "Nordic curl",
  "Bench press",
  "Incline bench press",
  "Decline bench press",
  "Close grip bench press",
  "Floor press",
  "Overhead press",
  "Push press",
  "Strict press",
  "Military press",
  "Seated shoulder press",
  "Landmine press",
  "Arnold press",
  "Dumbbell press",
  "Dumbbell bench press",
  "Dumbbell shoulder press",
  "Kettlebell press",
  "Barbell row",
  "Pendlay row",
  "Bent over row",
  "Renegade row",
  "Seal row",
  "Cable row",
  "Seated cable row",
  "Upright row",
  "Inverted row",
  "Dumbbell row",
  "Row",
  "Lat pulldown",
  "Pull up",
  "Chin up",
  "Assisted pull up",
  "Face pull",
  "Shrug",
  "Barbell shrug",
  "Clean",
  "Power clean",
  "Hang clean",
  "Hang power clean",
  "Squat clean",
  "Muscle clean",
  "Clean pull",
  "Clean and jerk",
  "Clean and press",
  "Snatch",
  "Power snatch",
  "Hang snatch",
  "Hang power snatch",
  "Muscle snatch",
  "Snatch balance",
  "Snatch pull",
  "Jerk",
  "Push jerk",
  "Split jerk",
  "Thruster",
  "High pull",
  "Sumo deadlift high pull",
  "Dumbbell curl",
  "Dumbbell fly",
  "Dumbbell snatch",
  "Dumbbell clean",
  "Dumbbell lunge",
  "Dumbbell deadlift",
  "Dumbbell thruster",
  "Lateral raise",
  "Front raise",
  "Rear delt fly",
  "Chest fly",
  "Pullover",
  "Farmer carry",
  "Suitcase carry",
  "Turkish get up",
  "Kettlebell swing",
  "Kettlebell snatch",
  "Kettlebell clean",
  "Kettlebell row",
  "Barbell curl",
  "Bicep curl",
  "Hammer curl",
  "Preacher curl",
  "Concentration curl",
  "Drag curl",
  "Skull crusher",
  "Triceps extension",
  "Overhead triceps extension",
  "Triceps pushdown",
  "Wrist curl",
  "Lunge",
  "Walking lunge",
  "Reverse lunge",
  "Lateral lunge",
  "Step up",
  "Leg press",
  "Leg extension",
  "Leg curl",
  "Seated leg curl",
  "Lying leg curl",
  "Calf raise",
  "Standing calf raise",
  "Seated calf raise",
  "Hip abduction",
  "Hip adduction",
  "Push up",
  "Pike push up",
  "Diamond push up",
  "Handstand push up",
  "Dip",
  "Muscle up",
  "Sit up",
  "Crunch",
  "V-up",
  "Toes to bar",
  "Hanging leg raise",
  "Knee raise",
  "Leg raise",
  "Plank",
  "Side plank",
  "Hollow hold",
  "Superman",
  "Bird dog",
  "Dead bug",
  "Russian twist",
  "Flutter kick",
  "Mountain climber",
  "Burpee",
  "Jumping jack",
  "Box jump",
  "Broad jump",
  "Bear crawl",
  "Wall sit",
  "Wall ball",
  "Jump rope",
  "Double under",
  "Sprint",
  "Cable fly",
  "Cable crossover",
  "Cable woodchop",
  "Cable rotation",
  "Cable pull through",
  "Pec deck",
  "Rowing machine"
];

export const extraWords: ReadonlySet<string> = new Set([
  "alternating",
  "arm",
  "banded",
  "bar",
  "barbell",
  "behind",
  "bodyweight",
  "bottom",
  "box",
  "cable",
  "chain",
  "close",
  "cluster",
  "complex",
  "continuous",
  "deficit",
  "double",
  "each",
  "eccentric",
  "elevated",
  "explosive",
  "fast",
  "from",
  "grip",
  "half",
  "hands",
  "heavy",
  "hold",
  "kettlebell",
  "knee",
  "knees",
  "left",
  "leg",
  "light",
  "machine",
  "medium",
  "moderate",
  "narrow",
  "neutral",
  "opposite",
  "paused",
  "plank",
  "plate",
  "position",
  "rack",
  "reverse",
  "right",
  "rotation",
  "round",
  "seated",
  "side",
  "single",
  "slow",
  "smith",
  "stance",
  "standing",
  "strict",
  "tempo",
  "under",
  "wide",
  "with"
]);
